export function getElementHeight(element) {
  return element && element.clientHeight;
}

export function disableMouseWheelOnNumberInputs() {
  document.addEventListener(
    'wheel',
    (event) => {
      const activeElement = document.activeElement;
      const targetElement = event.target;

      // Check if the target element is the same as the active element and is a number input
      if (
        targetElement &&
        targetElement.type === 'number' &&
        activeElement === targetElement
      ) {
        event.preventDefault(); // Prevent the default scroll behavior
      }
    },
    { passive: false }
  );
}